<template>
    <v-sheet>
        <v-divider class="primary border-2" />
        <v-data-table
            v-bind="{
                headers,

                items,
                itemKey: '_id',
                itemClass,
                itemsPerPage: -1,

                loading,
            }"
            hide-default-footer
            disable-filtering
            disable-sort
            @click:row="onClickRow"
        >
            <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
            <!-- <template #[`item.index`]="{ item, value }">
                <template v-if="item.isUserItem">
                    <v-icon small>mdi-account-circle-outline</v-icon>
                </template>
                <template v-else> {{ value.format() }}</template>
            </template> -->
            <template #[`item.subject`]="{ item }">
                <list-item-subject v-bind="{ item }" />
            </template>
            <template #[`item.isReplied`]="{ value }">
                <template v-if="value">
                    <span class="primary--text"> 답변완료 </span>
                </template>
                <template v-else>
                    <span> 답변대기 </span>
                </template>
            </template>
            <td slot="expanded-item" slot-scope="{ item }" :colspan="headers.length" class="pa-0 grey-f8">
                <list-item-content
                    v-bind="{
                        item,
                        items,
                        program,
                        loading,
                    }"
                    v-on="{
                        remove,
                        update,
                        updateItem,
                    }"
                />
            </td>
            <template #footer>
                <v-divider />
                <v-pagination v-model="page" :length="pageCount" :total-visible="11" color="primary" class="my-8" />
            </template>
        </v-data-table>
    </v-sheet>
</template>

<script>
import api from "@/api";
import { initExpoProgram, initExpoInquiry } from "@/assets/variables/inits";

import ListItemContent from "./list/list-item-content.vue";
import ListItemSubject from "./list/list-item-subject.vue";

const headers = [
    // { text: "#", value: "index", width: 60 },
    { text: "제목", value: "subject", cellClass: "text-start" },
    { text: "작성자", value: "user.name", width: 80 },
    { text: "작성일", value: "createdAt", width: 120, formatter: (value) => value?.toDate?.() || "-" },
    { text: "상태", value: "isReplied", width: 100 },
].map((item) => ({
    ...item,
    align: item.align ?? "center",
    class: (item.class || "") + " font-size-16",
    cellClass: (item.cellClass || "") + " font-size-16",
}));

export default {
    components: {
        ListItemContent,
        ListItemSubject,
    },
    props: {
        program: { type: Object, default: initExpoProgram },
    },
    data: () => ({
        // inquiries_user: [],
        inquiries: [],
        summary: { totalCount: 0 },

        limit: 10,
        page: 1,

        loading: false,

        headers,
    }),
    computed: {
        _program() {
            return this.program._id;
        },
        items() {
            let items = [];

            // if (this.page == 1) {
            //     items.push(
            //         ...this.inquiries_user.map((item) => ({
            //             ...item,
            //             isUserItem: true,
            //         }))
            //     );
            // }

            items.push(...this.inquiries);

            return items.map((item, index) => initExpoInquiry(item));
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
    },
    methods: {
        init() {
            this.search();
        },
        async search() {
            this.loading = true;
            try {
                let { _program, skip, limit } = this;

                // if (this.page == 1) {
                //     let { inquiries: inquiries_user } = await api.v1.expo.programs.inquiries.gets({
                //         _program,
                //         headers: { skip, limit, mode: "user" },
                //     });
                //     this.inquiries_user = inquiries_user;
                // }

                let { summary, inquiries } = await api.v1.expo.programs.inquiries.gets({
                    _program,
                    headers: { skip, limit },
                });
                this.inquiries = inquiries;
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },

        async remove({ _id }) {
            this.loading = true;
            try {
                const { _program } = this;
                await api.v1.expo.programs.inquiries.delete({ _id, _program });

                this.loading = false;

                let index = this.inquiries.findIndex((item) => item._id == _id);
                if (-1 < index) {
                    this.inquiries.splice(index, 1);
                    this.summary.totalCount -= 1;
                }

                await this.search();
            } finally {
                if (this.loading) this.loading = false;
            }
        },
        async update(item) {
            this.loading = true;
            try {
                item._program = this._program;
                let { inquiry } = await api.v1.expo.programs.inquiries.put(item);

                this.loading = false;

                inquiry = initExpoInquiry(inquiry);
                this.updateItem(inquiry);
            } finally {
                if (this.loading) this.loading = false;
            }
        },

        updateItem(inquiry) {
            const index = this.inquiries.findIndex(({ _id }) => _id == inquiry._id);
            if (0 <= index) this.inquiries.splice(index, 1, inquiry);
            else {
                this.inquiries = [inquiry, ...this.inquiries];
                this.summary.totalCount += 1;
            }
            this.inquiries = [...this.inquiries];

            // const index_user = this.inquiries_user.findIndex(({ _id }) => _id == inquiry._id);
            // if (0 <= index_user) this.inquiries_user.splice(index_user, 1, inquiry);

            this.search();
        },
        itemClass(item) {
            let className = "cursor-pointer";
            return className;
        },
        onClickRow(_, { expand, isExpanded }) {
            expand(!isExpanded);
        },
    },
    watch: {
        page() {
            this.search();
        },
    },
    mounted() {
        this.init();
    },
};
</script>


<style lang="scss" scoped>
::v-deep .v-pagination {
    margin-top: 0;
}

::v-deep .cursor-pointer {
    cursor: pointer;
}
</style>